//#region src/bite_log_eigen_event.ts
var BiteLogEigenEvent = /* @__PURE__ */ function(BiteLogEigenEvent) {
	/** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
	BiteLogEigenEvent[BiteLogEigenEvent["PaymentDeprecated"] = 1] = "PaymentDeprecated";
	BiteLogEigenEvent[BiteLogEigenEvent["TerminalDisconnected"] = 5] = "TerminalDisconnected";
	return BiteLogEigenEvent;
}(BiteLogEigenEvent || {});
//#endregion
export { BiteLogEigenEvent };

//# sourceMappingURL=bite_log_eigen_event.js.map